import React from "react";

import { GridResult } from "2g-grid";

import useZdrojeTypyGrid from "./useZdrojeTypyGrid";

export function ZdrojeTypyGrid() {
  const grid = useZdrojeTypyGrid();
  return <GridResult {...grid} />;
}

ZdrojeTypyGrid.propTypes = {};

export default React.memo(ZdrojeTypyGrid);
